import React from 'react';

import { useIsWideScreen } from '../contexts/WebsiteContext';
import { useResto } from '../contexts/RestoContext';
import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Info from '../components/Info';
import Description from '../components/Description';
import Opening from '../components/Opening';
import Access from '../components/Access';
import Suppliers from '../components/Suppliers';
import Menus from '../components/Menus';
import Footer from '../components/Footer/Footer';
import Presss from '../components/Presss';

const Home = () => {
  const { restoData } = useResto();
  const isWideScreen = useIsWideScreen();

  return (
    <div>
      <NavigationBar />
      <h1 style={{ display: 'none'}}>{ restoData.label }</h1>

      <div className='p-3'>
        <MediaList mediaKey='HOME_TOP' maxItems={10}  isShortLine={true} />
        <Info />
        <Description />
        <Opening />
        <Access />
        { !isWideScreen && <Suppliers isSubtitle={true} />}
        <Presss />
        <MediaList mediaKey='HOME_BOTTOM' maxItems={10}  isShortLine={true} />
      </div>
      <Menus />
      <Footer />
    </div>
  );
}

export default Home;